import Vue from 'vue';

import {
  BVModalPlugin
} from 'bootstrap-vue';

Vue.use(BVModalPlugin);
